export default __webpack_public_path__ + "static/media/group-16-copy.59166617.svg";